import { createSlice } from '@reduxjs/toolkit';

interface MainMenuState {
  areDisabilitiesEnabled: boolean;
  areDisabilitiesLoading: boolean;
  areContributionsEnabled: boolean;
  areContributionsLoading: boolean;
}

const initialState: MainMenuState = {
  areDisabilitiesEnabled: false,
  areDisabilitiesLoading: false,
  areContributionsEnabled: false,
  areContributionsLoading: false
};

export const mainMenuSlice = createSlice({
  name: 'mainMenu',
  initialState,
  reducers: {
    setDisabilitiesEnabled: (state, action) => {
      state.areDisabilitiesEnabled = action.payload;
    },
    setDisabilitiesLoading: (state, action) => {
      state.areDisabilitiesLoading = action.payload;
    },
    setContributionsEnabled: (state, action) => {
      state.areContributionsEnabled = action.payload;
    },
    setContributionsLoading: (state, action) => {
      state.areContributionsLoading = action.payload;
    }
  }
});

export const MainMenuActions = mainMenuSlice.actions;
export const MainMenuReducer = mainMenuSlice.reducer;
